import script from "./CountDownTxtCss.vue?vue&type=script&setup=true&lang=ts"
export * from "./CountDownTxtCss.vue?vue&type=script&setup=true&lang=ts"

import "./CountDownTxtCss.vue?vue&type=style&index=0&id=e9cfe898&scoped=true&lang=sass"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9cfe898"]])

export default __exports__